export default {
  patient: {
    firstName: 'Nombre de pila',
    lastName: 'Apellido',
    medications: {
      label: 'Medicamentos',
      new: 'Agregar nuevo medicamento',
      warning: {
        noMedications: 'Sin medicamentos',
      },
      noMedicationsMessage: 'No hay solicitudes de medicamentos para esta persona.',
    },
  },
}
